import { baseUrl } from '@fs/zion-config'

const baseUrlToIdent = {
  'https://integration.familysearch.org': 'https://identint.familysearch.org',
  'https://integration-ru.familysearch.org': 'https://identint.familysearch.org',
  'https://beta.familysearch.org': 'https://identbeta.familysearch.org',
  'https://beta-ru.familysearch.org': 'https://identbeta.familysearch.org',
}

export default function getIdentBaseUrl() {
  return baseUrlToIdent[baseUrl] || 'https://ident.familysearch.org'
}
